export default __webpack_public_path__ + "static/media/project.ada360e1.svg";